module.exports.Directive = function() {
  return {
    restrict: "E",
    scope: {},
    templateUrl: "/modules/common/header-component/header-component.view.html"
  };
};
